import React, { useEffect } from 'react'
import classes from './AdminContexts.module.css'
import { Button, Flex, Grid, Table, Tbody, Td, Th, Thead, Tr, useDisclosure } from '@chakra-ui/react'
import { useAccessAPI } from '../../hooks/useAccessAPI'
import UsersService from '../../API/UsersService'
import UmSpinner from '../../components/UI/UmSpinner'
import AdminContextModal from '../../components/Modals/AdminContextModal'
import RoleTag from '../../components/UI/RoleTag'
import { useAdminContextModalStore } from '../../store/modalsStore'
import { useAdminStore } from '../../store/adminStore'
import { usePagination } from '../../hooks/usePagination'
import Pagination from '../../components/Pagination/Pagination'

function AdminContextsTable() {
    const pagination = usePagination()
    const [data, setData] = useAdminStore(state => [state.contextsPagePaginationData, state.setContextsPagePaginationData])
    const filters = useAdminStore(state => state.contextsPageFilters)
    const setModalUser = useAdminContextModalStore(state => state.setModalUser)
    const modalDisclosure = useDisclosure()
    const fetchUsers = useAccessAPI(UsersService.getUsers)

    const fetchPaginationData = async (page) => {
        const response = await fetchUsers({
            page: page,
            ...filters,
        })
        if (response?.status === 200) {
            setData(response.data)
            pagination.setMaxPage(Math.ceil(response.data.count / 10))
        }
    }

    useEffect(() => {
        if (pagination.page === 1)
            fetchPaginationData(1)
        else
            pagination.setPage(1)
    }, [filters])

    useEffect(() => {
        fetchPaginationData(pagination.page)
    }, [pagination.page])

    useEffect(() => {
        if (data)
            pagination.setMaxPage(Math.ceil(data.count / 10))
    }, [data])

    if (!data)
        return <UmSpinner />

    return (
        <Grid>
            <AdminContextModal
                isOpen={modalDisclosure.isOpen}
                onClose={modalDisclosure.onClose}
            />
            <div className={classes.table}>
                <Table>
                    <Thead>
                        <Tr>
                            <Th>Имя</Th>
                            <Th>Почта</Th>
                            <Th>Контексты</Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {data.results.map((user) => (
                            <Tr key={`user-${user.id}-contexts`}>
                                <Td>{`${user.lastname} ${user.firstname}`}</Td>
                                <Td>{user.email}</Td>
                                <Td>
                                    <Flex gap='8px'>
                                        <Button
                                            size='sm'
                                            onClick={() => {
                                                setModalUser(user)
                                                modalDisclosure.onOpen()
                                            }}
                                        >
                                            Изменить
                                        </Button>
                                        {user.contexts.map(c => (
                                            <RoleTag
                                                role={c.role}
                                                colorScheme={c.role.id === 1 ? 'orange' : 'gray'}
                                                key={`${c.id}${c.role.id}`} />
                                        ))}
                                    </Flex>
                                </Td>
                            </Tr>
                        ))}
                    </Tbody>
                </Table>
            </div>
            <Pagination pagination={pagination} disabled={!data || !data?.count} />
        </Grid>
    )
}

export default AdminContextsTable
